import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

// import DefaultTooltipContent from 'recharts/lib/component/DefaultTooltipContent';
import { BarChart, Bar, Cell, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Line, DefaultTooltipContent } from 'recharts';

const propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired, // Date short or Hour
    count: PropTypes.number.isRequired,
    amount: PropTypes.number.isRequired,
  })),
  // currency: PropTypes.string.isRequired,
}

const defaultProps = {
  data: [],
  // currency: "₡"
}

const SalesLineChart = (props) => {
  
  const renderTooltip =  useCallback( (stuff) => {
    const lineData = stuff.payload[0];
    return(
      <div className="charts-custom-tooltip">
        <p>{ stuff.label }</p>
        { lineData &&
          <div>
            <p style={{ color: lineData.color }}>
              { `${lineData.name}: ${lineData.payload.formatted_amount}` }
            </p>
            <p style={{ color: "#AA11FF" }}>
              { `Unidades: ${lineData.payload.count}` }
            </p>
          </div>
        }
      </div>
  )}, []);

  return (
    <ResponsiveContainer width="100%" height={100}>
      <LineChart
        data={ props.data }
        margin={{
          top: 12,
          right: 24,
          left: 24,
          bottom: 12
        }}
      >
        <XAxis dataKey="name" hide={false} />
        <Tooltip content={ renderTooltip } />
        <Line name="Monto" type="monotone"  stroke="#00b6e0" dataKey="amount" fill="#00b6e0" dot={false} />

        {/* <Line name="Unidades" type="monotone" stroke="#AA11FF" dataKey="count" fill="#AA11FF" /> */}
      </LineChart>
    </ResponsiveContainer>
  )
};

SalesLineChart.propTypes = propTypes;
SalesLineChart.defaultProps = defaultProps;

export default SalesLineChart;